module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTMyMCAwaDMyMHY0ODBIMzIweiIvPgogIDxwYXRoIGZpbGw9IiMwMDYyMzMiIGQ9Ik0wIDBoMzIwdjQ4MEgweiIvPgogIDxwYXRoIGQ9Ik00MjQgMTgwYTEyMCAxMjAgMCAxIDAgMCAxMjAgOTYgOTYgMCAxIDEgMC0xMjBtNCA2MGwtMTA4LTM1LjIgNjcuMiA5MlYxODMuMmwtNjcuMiA5MnoiIGZpbGw9IiNkMjEwMzQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/dz.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/dz.svg
// module chunks = 0